/** Build a URL-safe slug from a title. */
export const slugifyPublicPath = (value: unknown): string => {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return normalized
}

/**
 * True when the title is mostly Latin / ASCII letters+digits (English-friendly).
 * Non-Latin titles (Tamil, etc.) should not auto-fill the slug.
 */
export const isEnglishFriendlyTitle = (value: unknown): boolean => {
  const text = String(value ?? '').trim()
  if (!text) return false
  const letters = text.replace(/[^a-zA-Z\u00C0-\u024F]/g, '')
  if (!letters) return false
  const nonLatin = text.replace(/[\s0-9a-zA-Z\u00C0-\u024F.,'"&()/\-_:!?;]/g, '')
  return nonLatin.length === 0
}

/** Prefer title slug; fall back to id so create-time URLs stay unique. */
export const buildPublicSlug = (title: unknown, id?: string | number | null): string => {
  const fromTitle = isEnglishFriendlyTitle(title) ? slugifyPublicPath(title) : ''
  if (fromTitle) return fromTitle
  const idPart = String(id ?? '').trim()
  return idPart || ''
}

export const venueEventPublicPath = (
  kind: 'events' | 'festivals' | 'news',
  id: string | number,
  slug?: string,
): string => {
  const clean = slugifyPublicPath(slug)
  return clean ? `/venue/${kind}/${id}/${clean}` : `/venue/${kind}/${id}`
}

export const venueFundraisingPublicPath = (id: string | number, slug?: string): string => {
  const clean = slugifyPublicPath(slug)
  return clean ? `/venue/fundraising/${id}/${clean}` : `/venue/fundraising/${id}`
}
